import { LOCIZE_NS, MUTATION_KEYS } from '@avanta/shared/constants/common';
import { ErrorService } from '@avanta/shared/services/error';
import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';
import { FileService } from 'services/files';
import { type AppointmentWithDetails } from 'types/appointments';
import { openReportPdf } from 'utils/storage';

export const useViewSessionReport = (
  appointment: AppointmentWithDetails
): { viewReport: () => void; isPending: boolean } => {
  const { t } = useTranslation(LOCIZE_NS.INSURANCE);

  const { mutate, isPending } = useMutation({
    mutationKey: [MUTATION_KEYS.DOWNLOAD_ENTERPRISE_SESSION_REPORT, appointment.id],
    mutationFn: async () => {
      if (!appointment.id) {
        toast.info(t('SessionsPage.viewReport.empty'));
        return;
      }

      const { data: reports } = await FileService.getReportsByAppointment(appointment.id);
      const report = reports.find(item => Boolean(item.pdf));

      if (!report) {
        toast.info(t('SessionsPage.viewReport.empty'));
        return;
      }

      await openReportPdf(report);
    },
    onError: error => {
      if (isAxiosError(error)) {
        ErrorService.handlerErrorRequest(error);
      }
    },
  });

  return {
    viewReport: () => mutate(),
    isPending,
  };
};
